import React, { useState, useEffect, useCallback } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export function withPagePerfMarker(WrappedComponent, perfMarkerName) {
  const Wrapper = (props) => {
    const { perfMarker } = props || {};
    const [dataLoadedOnce, setDataLoadedOnce] = useState(false);
    const [pagePerfMarker] = useState(() => {
      const marker = perfMarker.createChild(perfMarkerName);
      marker.willInit();
      return marker;
    });

    const setDataLoaded = useCallback(() => {
      setDataLoadedOnce(true);
    }, []);

    useEffect(() => {
      if (dataLoadedOnce && pagePerfMarker) {
        pagePerfMarker.done();
      }
    }, [dataLoadedOnce]);

    return <WrappedComponent {...props} pagePerfMarker={pagePerfMarker} setDataLoaded={setDataLoaded} />;
  };

  Wrapper.displayName = `withPagePerfMarker(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
}
